import { createFileRoute } from '@tanstack/react-router';

import { SavedProfilesPage } from '@/features/saved-profiles';

export const Route = createFileRoute('/workspace/$workspaceId/saved-profiles/')({
  component: SavedProfilesPage,
});
